import { v4 as uuidv4 } from 'uuid';
import { SliderLayout } from '../../../../vtex-apps/slider-layout/SliderLayout/default';
import { FlexLayoutCol } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { InfoCardList } from '../../../../vtex-apps/info-card-list/InfoCardList/default';

export default function BrandGroup() {
	return {
		componentName: 'FlexLayoutRow',
		componentId: uuidv4(),
		componentGroup: 'BrandGroup',
		props: FlexLayoutRow({
			blockClass: 'flex-row__brand-group-3',
			mzTitle: 'MZ | Marcas',
			colSizing: 'auto',
		}).props,
		variables,
		childrenComponents: [
			FlexLayoutCol(
				{
					blockClass: 'flex-col__brand-group-3',
					width: '100%',
				},
				[
					RichText({
						mzTitle: 'MZ | Título',
						textPosition: 'CENTER',
						text: 'Monte o seu Kit agora mesmoooo',
						blockClass: 'header-text__brand-group-3',
					}),
					InfoCardList({ infoCards }, [
						SliderLayout({
							label: 'slider',
							itemsPerPage: {
								desktop: 6,
								tablet: 3,
								phone: 1,
							},

							blockClass: 'slider__brand-group-3',
							fullWidth: true,
						}),
					]),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--support-color-3', to: '--brand-group-3-background', name: 'Background' },
			{ from: '--white', to: '--brand-group-3-text-color', name: 'Text' },
			{ from: '--brand-color-primary-pure', to: '--brand-group-3-slider-color', name: 'Slider' },
			{ from: '--white', to: '--brand-group-3-slider-arrow-color', name: 'Arrow' },
			{ from: '--brand-color-primary-pure', to: '--brand-group-3-dots-color', name: 'Dots' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-sm', to: '--brand-group-3-image-radius', name: 'Image' },
			{ from: '--border-radius-sm', to: '--brand-group-3-slider-radius', name: 'Slider' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxl', to: '--brand-group-3-heading-fontsize', name: 'Heading' },
			{ from: '--font-size-sm', to: '--brand-group-3-label-fontsize', name: 'Label' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-700', to: '--brand-group-3-heading-fw', name: 'Heading' },
			{ from: '--font-weight-400', to: '--brand-group-3-body-fw', name: 'Body' },
		],
	},
	{
		type: 'typography',
		list: [{ from: '--main-font', to: '--brand-group-3-fontfamily', name: 'Font Family' }],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxs', to: '--brand-group-3-dot-width', name: 'Dot Width' },
			{ from: '--spacing-xxs', to: '--brand-group-3-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-nano', to: '--brand-group-3-dot-height', name: 'Dot Height' },
			{ from: '--spacing-nano', to: '--brand-group-3-dot-height-active', name: 'Dot Height Active' },
			{ from: '--spacing-sm', to: '--brand-group-3-arrow-height', name: 'Altura seta' },
			{ from: '--spacing-sm', to: '--brand-group-3-arrow-width', name: 'Largunra seta' },
		],
	},
];

const infoCards = [
	{
		id: 'info-card-category-1',
		isFullModeStyle: false,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683046405966-brand-group-img-5.png',
		callToActionText: 'Materiais para Hospitais e Clínicas',
		callToActionUrl: '/moda-praia',
		callToActionMode: 'link',
		blockClass: 'info-card-img__brand-group-3',
		textAlignment: 'center',
	},
	{
		id: 'info-card-category-2',
		isFullModeStyle: false,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683046405966-brand-group-img-5.png',
		callToActionText: 'Kit Profissional para Médicos',
		callToActionUrl: '/camisetas',
		callToActionMode: 'link',
		blockClass: 'info-card-img__brand-group-3',
		textAlignment: 'center',
	},
	{
		id: 'info-card-category-3',
		isFullModeStyle: false,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683046405966-brand-group-img-5.png',
		callToActionText: 'Kit Profissional Enfermagem',
		callToActionUrl: '/camisetas',
		callToActionMode: 'link',
		blockClass: 'info-card-img__brand-group-3',
		textAlignment: 'center',
	},
	{
		id: 'info-card-category-4',
		isFullModeStyle: false,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683046405966-brand-group-img-5.png',
		callToActionText: 'Estudantes e Residência',
		callToActionUrl: '/calcados',
		callToActionMode: 'link',
		blockClass: 'info-card-img__brand-group-3',
		textAlignment: 'center',
	},
	{
		id: 'info-card-category-5',
		isFullModeStyle: false,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683046405966-brand-group-img-5.png',
		callToActionText: 'Equipamentos para Homecare',
		callToActionUrl: '/polos',
		callToActionMode: 'link',
		blockClass: 'info-card-img__brand-group-3',
		textAlignment: 'center',
	},
	{
		id: 'info-card-category-2',
		isFullModeStyle: false,
		imageUrl: 'https://hefesto-upload-images.s3.amazonaws.com/1683046405966-brand-group-img-5.png',
		callToActionText: 'Kit Profissional para Médicos',
		callToActionUrl: '/camisetas',
		callToActionMode: 'link',
		blockClass: 'info-card-img__brand-group-3',
		textAlignment: 'center',
	},
];
